import coordinatesSchema from '@data/schemas/coordinates'
import locationCountrySchema from '@data/schemas/locationCountry'
import { ObjectSchema, object, string } from 'yup'

const schema: ObjectSchema<TLocation, TLocation> = object<TLocation>()
    .shape({
        city: string().required().strict().nullable(),
        country: locationCountrySchema,
        coordinates: coordinatesSchema.strict(),
        placeId: string().optional().nullable(),
    })
    .noUnknown()

export default schema
